<form class="mb-2" #themeForm="ngForm">

	<div class="p-fluid grid formgrid p-2">

		<div class="field-checkbox col-12">
			<p-checkbox
				name="thm_actif"
				inputId="thm_actif"
				[(ngModel)]="theme.thm_actif"
				[binary]="true"
				inputId="binary"
				[label]="'themes.active_state' | translate"
				[disabled]="!editMode"
			></p-checkbox>
		</div>

		<!-- Nom -->
		<div class="field col-6">
			<label for="thm_nom">
				{{ 'common.name_label' | translate }}
			</label>
			<input
				type="text"
				pInputText
				name="thm_nom"
				[(ngModel)]="theme.thm_nom"
				[attr.placeholder]="'common.name_label' | translate"
				[readOnly]="!editMode"
				required
			/>
		</div>

		<div class="col-12"></div>

		<!-- Famille -->
		<div class="field col-6">
			<label for="thm_nom">
				{{ 'families.family_label' | translate }}
			</label>
			<famille-selector
				name="fam_id"
				[(ngModel)]="theme.fam_id"
				[readonly]="!editMode"
				[required]="true"
			>
			</famille-selector>
		</div>

		<!-- Description -->

		<div class="field col-12">
			<label for="thm_description">
				{{ 'common.description_label' | translate }}

			</label>
			<textarea
				pInputTextarea
				name="thm_description"
				[(ngModel)]="theme.thm_description"
				[autoResize]="true"
				[readOnly]="!editMode"
			></textarea>
		</div>

		<!-- Historique -->

		<div *ngIf="!isCreation && showHistorique" class="field col-12">
			<label for="history">
				{{ 'common.history_label' | translate }}
			</label>
			<div>
				<historique-element-nomenclature [element]="theme"></historique-element-nomenclature>
			</div>
		</div>

	</div>

	<div class="text-center">
		<!-- Bouton éditer -->
		<button
			*ngIf="!editMode && canEdit"
			type="button"
			pButton
			class="label-md-none"
			[label]="'common.edition_button_label' | translate"
			icon="pi pi-pencil"
			(click)="toggleEditMode()"
		></button>

		<!-- Bouton enregistrer -->
		<button
			*ngIf="!!editMode"
			type="button"
			pButton
			class="label-md-none"
			[label]="'common.save_button_label' | translate"
			icon="pi pi-save"
			(click)="submit()"
			[disabled]="!themeForm.valid"
		></button>
	</div>

</form>
